import { Component, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { DokumentAfsendelseService } from '@features/dokumenter/afsendelse/dokument-afsendelse.service';

@Component({
  selector: 'app-dokument-afsendelse-result',
  imports: [TableRowDirective, TableModule, DatePipe],
  templateUrl: './dokument-afsendelse-result.component.html',
  styleUrl: './dokument-afsendelse-result.component.css',
})
export class DokumentAfsendelseResultComponent {
  dokAfsendelseService = inject(DokumentAfsendelseService);
  data = this.dokAfsendelseService.datasource.data;

  onLazyLoad(event: TableLazyLoadEvent) {
    this.dokAfsendelseService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
